import React from "react";
import PropTypes from "prop-types";
import { downloadReport } from "../../helpers/he-reportBuild-python";
import HeSearch from "../HeSearch";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faInfoCircle, faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import ReactTooltip from "react-tooltip";


const processingMsg = {
    inProgress: (
        <>
            <FontAwesomeIcon icon={faSpinner} style={{ paddingRight: 5 }} spin />
            Downloading report.
        </>
    ),
    success: (
        <>
            <FontAwesomeIcon icon={faThumbsUp} style={{ paddingRight: 5 }} />
            Check your download folder.
        </>
    ),
    error: (
        <>
            <FontAwesomeIcon icon={faThumbsDown} style={{ paddingRight: 5 }} />
            Error downloading report.
        </>
    ),
};

class HeEPS_DownloadReport extends React.Component {
    constructor() {
        super();

        this.state = {
            modalIsOpen: false,
            printFormat: "xlsx",
            customSubTitle: "",
            customRegionName:"",
            // benchmarkGeoId:"0",
            // benchmarkGeoName:"United States",
            isProcessing: false,
            doneProcessing: false,
            errorProcessingRequest: false,
            downloadingAlertContent: null,
            // ,
            // newBenchmarkGeo: null
        };
    }
    componentDidMount() {
        this.props.onRef(this);
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
    }
    componentDidUpdate() {
        if (this.props.excelOnly && this.state.printFormat !== "xlsx") {
            this.setState({
                printFormat: "xlsx",
            });
        }
    }

    submitViaCors() {
        let _this = this;
        const rptFormat = this.props.printFormatOptions === "both" ? this.state.printFormat : this.props.printFormatOptions;
        this.setState({ downloadingAlertContent: processingMsg.inProgress });
        let benchmarkFips = this.props.benchmarkGeo.id || this.props.benchmarkGeo.value || this.props.benchmarkGeo.fips;

        downloadReport({
            report_template_name: _this.props.TemplateName,
            report_sub_heading: _this.state.customSubTitle !== "" ? _this.state.customSubTitle : _this.props.defaultSubTitle !== "" ? _this.props.defaultSubTitle : _this.props.Group2_overrideName,
            report_format: rptFormat,
            request_source: _this.props.requestSource,
            position_keys: [
                {
                    position_key: 1,
                    geo_codes: _this.props.Group1_geoCodes.toString(),
                    override_name: _this.props.Group1_overrideName,
                    is_aggregate: _this.props.Group1_Aggregate ? true : false,
                    is_region: _this.props.Group1_Region ? true : false,
                    is_benchmark: _this.props.Group1_Benchmark ? true : false,
                },
                {
                    position_key: 2,
                    geo_codes: _this.props.Group1_geoCodes.toString(),
                    override_name: _this.state.customRegionName !== "" ? _this.state.customRegionName : "",
                    is_aggregate: _this.props.Group2_Aggregate ? true : false,
                    is_region: _this.props.Group2_Region ? true : false,
                    is_benchmark: _this.props.Group2_Benchmark ? true : false,
                },
                {
                    position_key: 3,
                    geo_codes: benchmarkFips.toString(),
                    override_name: _this.props.benchmarkGeo.label,
                    is_aggregate: _this.props.Group3_Aggregate ? true : false,
                    is_region: _this.props.Group3_Region ? true : false,
                    is_benchmark: _this.props.Group3_Benchmark ? true : false,
                },
            ],
            base64_graphics: [

            ],
        },{auth_key:"58f0d42d-0ed7-493d-afe4-f042d5c3aac3"}).then(
            () => {
                _this.setState({ downloadingAlertContent: processingMsg.success }, () => {
                    setTimeout(() => {
                        _this.setState({
                            downloadingAlertContent: null,
                        });
                    }, 3000);
                });
            },
            () => {
                _this.setState({ downloadingAlertContent: processingMsg.error }, () => {
                    setTimeout(() => {
                        _this.setState({
                            downloadingAlertContent: null,
                        });
                    }, 3000);
                });
            }
        );
      
    }

    renderProcessingOverlay() {
        if (!this.state.downloadingAlertContent) return null;
        return (
            <div
                style={{
                    zIndex: 99999,
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(50,50,50,0.8)",
                }}
            >
                <div
                    style={{
                        margin: 0,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: 28,
                        color: "white",
                    }}
                >
                    <p style={{ margin: 0, minWidth: 400 }}>{this.state.downloadingAlertContent}</p>
                </div>
            </div>
        );
    }
    renderProcessingSpinner() {
        if (!this.state.isProcessing) {
            return null;
        }
        return (
            <div
                style={{
                    textAlign: "center",
                    lineHeight: "300px",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 99999,
                    backgroundColor: "rgba(255,255,255,0.5)",
                }}
            >
                <FontAwesomeIcon icon={faSpinner} spin size="4x" />
            </div>
        );
    }

    renderCheckDownloadText() {
        return (
            <div
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 100,
                    zIndex: 99999,
                    color: "orange",
                }}
            >
                <CSSTransition in={this.state.doneProcessing} timeout={500} classNames="HeEPS-DownloadReport-CheckDownloadsWarning" unmountOnExit>
                    <div className="HeEPS-DownloadReport-CheckDownloadsWarning">Check Download Folder</div>
                </CSSTransition>
            </div>
        );
    }

    renderErrorText() {
        return (
            <div
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 100,
                    zIndex: 99999,
                    color: "red",
                }}
            >
                <CSSTransition in={this.state.errorProcessingRequest} timeout={500} classNames="HeEPS-DownloadReport-CheckDownloadsWarning" unmountOnExit>
                    <div className="HeEPS-DownloadReport-CheckDownloadsWarning">Error Generating Report</div>
                </CSSTransition>
            </div>
        );
    }

    renderTitleField() {
        if (this.props.hideTitleField) return null;
        return (
            <>
                <div style={{ fontWeight: 700 }}>Report Title</div>
                <div style={{ paddingLeft: 10 }}>
                    <i>{this.props.defaultTitle}</i>
                </div>
                <br />
            </>
        );
    }
    renderSubtitleField() {
        if (this.props.hideSubtitleField) return null;
        return (
            <>
                <div style={{ fontWeight: 700 }}>Report Subtitle</div>
                <div style={{ paddingLeft: 10 }}>
                    <input
                        autoComplete='nope'
                        style={{ width: "100%" }}
                        type="text"
                        placeholder={"Default: " + (this.props.defaultSubTitle === "" ? this.props.Group2_overrideName : this.props.defaultSubTitle)}
                        value={this.state.customSubTitle}
                        onChange={(evt) => {
                            let val = evt.currentTarget.value;
                            this.setState({
                                customSubTitle: val,
                            });
                        }}
                    />
                </div>
                <br />
            </>
        );
    }
    renderRegionNameField() {
        if (this.props.hideRegionNameField) return null;
        return (
            <>
                <div style={{ fontWeight: 700 }}>Region Name</div>
                <div style={{ paddingLeft: 10 }}>
                    <input
                        autoComplete='nope'
                        style={{ width: "100%" }}
                        type="text"
                        placeholder={"Default: " + (this.state.customRegionName === "" ? this.props.Group2_overrideName : this.state.customRegionName)}
                        value={this.state.customRegionName}
                        onChange={(evt) => {
                            let val = evt.currentTarget.value;
                            this.setState({
                                customRegionName: val,
                            });
                        }}
                    />
                </div>
                <br />
            </>
        );
    }
    render() {
        return (
            <div style={{ position: "relative" }}>
                {this.renderProcessingOverlay()}
                <div style={{ padding: "5px" }}>
                    {this.renderProcessingSpinner()}
                    {this.renderCheckDownloadText()}
                    {this.renderErrorText()}
                    {this.renderTitleField()}
                    {this.renderSubtitleField()}
                    {this.renderRegionNameField()}

                    <div style={{ fontWeight: 700 }}>
                        Comparison Location
                        <span data-tip={""}>
                            <FontAwesomeIcon icon={faInfoCircle} style={{ paddingLeft: 5 }} />
                        </span>
                        <ReactTooltip effect="solid">Select a state or county.</ReactTooltip>
                    </div>
                    <div style={{ paddingLeft: 10 }}>
                        <HeSearch
                            geoTypes="he-state,he-county"
                            placeholder={this.props.benchmarkGeo.label}
                            defaultStyle={false}
                            onSelect={(val) => {
                                if (this.props.onBenchmarkGeoUpdate) {
                                    this.props.onBenchmarkGeoUpdate({
                                        id: val.id,
                                        label: val.label,
                                    });
                                }
                            }}
                        />
                    </div>
                    <br />
                    
                    <div
                        style={{
                            display: this.props.printFormatOptions !== "both" ? "none" : "block",
                        }}
                    >
                        <div style={{ fontWeight: 700 }}>File Format</div>
                        <div style={{ paddingLeft: 10 }}>
                            <input
                                autoComplete='nope'
                                style={{ marginRight: 3 }}
                                type="radio"
                                value="xlsx"
                                checked={this.state.printFormat === "xlsx"}
                                onChange={() => {
                                    this.setState({ printFormat: "xlsx" });
                                }}
                            />
                            Excel
                            <br />
                            <input
                                autoComplete='nope'
                                style={{ marginRight: 3 }}
                                type="radio"
                                value="pdf"
                                disabled={this.props.excelOnly}
                                checked={this.state.printFormat === "pdf"}
                                onChange={() => {
                                    this.setState({ printFormat: "pdf" });
                                }}
                            />
                            <span
                                style={{
                                    color: this.props.excelOnly ? "lightgrey" : "black",
                                }}
                            >
                                PDF
                            </span>
                        </div>
                        <div
                            className="warning"
                            style={{
                                display: this.props.excelOnly ? "block" : "none",
                            }}
                        >
                            PDF not available for reports with &gt; 5 locations.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HeEPS_DownloadReport.propTypes = {
    TemplateName: PropTypes.string,
    requestSource: PropTypes.string.isRequired,
    printFormatOptions: PropTypes.string,
    excelOnly: PropTypes.bool,
    /** Currently hardcoded in templates.  Provided as a mechanism of passing to fromt-end form. */
    defaultTitle: PropTypes.string,
    defaultSubTitle: PropTypes.string,
    hideTitleField: PropTypes.bool,
    hideSubtitleField: PropTypes.bool,
    hideRegionNameField: PropTypes.bool,

    /** Comma sepeated list of geocodes */
    Group1_geoCodes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    /** Custom Name for the group */
    Group1_overrideName: PropTypes.string,
    /** Should the geos be aggregated? */
    Group1_Aggregate: PropTypes.bool,
    /** Region? */
    Group1_Region: PropTypes.bool,
    /** Should the group be used as a Benchmark? */
    Group1_Benchmark: PropTypes.bool,

    /** Comma sepeated list of geocodes */
    //Group2_geoCodes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    /** Custom Name for the group */
    Group2_overrideName: PropTypes.string,
    /** Should the geos be aggregated? */
    Group2_Aggregate: PropTypes.bool,
    /** Region? */
    Group2_Region: PropTypes.bool,
    /** Should the group be used as a Benchmark? */
    Group2_Benchmark: PropTypes.bool,

    /** Comma sepeated list of geocodes */
    Group3_geoCodes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    /** Custom Name for the group */
    Group3_overrideName: PropTypes.string,
    /** Should the geos be aggregated? */
    Group3_Aggregate: PropTypes.bool,
    /** Region? */
    Group3_Region: PropTypes.bool,
    /** Should the group be used as a Benchmark? */
    Group3_Benchmark: PropTypes.bool,

    onRef: PropTypes.func,
    benchmarkGeo: PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
    }).isRequired,
    onBenchmarkGeoUpdate: PropTypes.func.isRequired,
};

HeEPS_DownloadReport.defaultProps = {
    TemplateName: null,
    requestSource: null,
    printFormatOptions: "both",
    defaultTitle: "",
    defaultSubTitle: "",
    hideTitleField: false,
    hideSubtitleField: false,
    hideRegionNameField: true,

    Group1_geoCodes: [],
    Group1_overrideName: "",
    Group1_Aggregate: false,
    Group1_Region: false,
    Group1_Benchmark: false,

    //Group2_geoCodes: [],
    Group2_overrideName: "",
    Group2_Aggregate: true,
    Group2_Region: true,
    Group2_Benchmark: false,

    Group3_geoCodes: ["0"],
    Group3_overrideName: "United States",
    Group3_Aggregate: true,
    Group3_Region: false,
    Group3_Benchmark: true,
};

export default HeEPS_DownloadReport;
